import {Component, EventEmitter, Input, Output} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment';

@Component({
  selector: 'leada-datepicker',
  templateUrl: './leada-datepicker.component.html',
  styleUrls: ['./leada-datepicker.component.css'],
})
export class LeadaDatepickerComponent {

  @Input() public minDate: Date;
  @Input() public isOptional: boolean;
  @Output() public dateChange: EventEmitter<Date> = new EventEmitter();

  @Input()
  set date(value: Date) {
    this.utcDate = value;
  }

  @Input() public disabled: boolean = false;

  public utcDate: Date;

  public get valid(): boolean {
    return this.utcDate ? true : false;
  }

  public get invalid(): boolean {
    return !this.valid;
  }

  public handleDateChange(date: Date): void { // tslint:disable-line
    this.utcDate = date;

    const newDate: Moment = moment(date);
    newDate.add(newDate.utcOffset(), 'minutes');

    this.dateChange.emit(newDate.toDate());
  }

  public get startDate(): string {
    if (!this.utcDate) {
      return '';
    }

    const date: Moment = moment(this.utcDate);
    return date.format('DD.MM.YYYY');
  }

  private resetDate(): void { // tslint:disable-line
    this.utcDate = undefined;
    this.dateChange.emit(null);
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/leada-datepicker/leada-datepicker.component.ts